import React, { useState } from 'react'
import Calendar from 'react-calendar'
const RightSidebar = () => {

    const [dateState, setDateState] = useState(new Date())
    const changeDate = (e) => {
        setDateState(e)
    }
    return (
        <div>
            <div class="card RightSidebar" >

                <div class="card-body">
                    <img src="https://cdnn1.img.sputnik.tj/img/102787/34/1027873402_461:0:1701:1363_1920x0_80_0_0_4682aa79314a55c9c9499d7c035029c7.jpg" class="card-img-top" alt="Fissure in Sandstone" />
                    <div className='p-3' >
                        <span style={{ "fontSize": "12px", "textAlign": "center" }}>
                            <a href='https://maorif.tj/message/payomi-prezidenti-umurii-toikiston-peshvoi-millat-mutaram-emomal-ramon-ba-malisi-ol-2020'> Паёми Президенти Ҷумҳурии Тоҷикистон, Пешвои миллат, муҳтарам Эмомалӣ Раҳмон ба Маҷлиси Олӣ </a>
                        </span>
                    </div>
                </div>
            </div>

            <div class="p-4">
                <div class="card">
                    <div class="card-body">
                        <img src="https://maorif.tj/storage/image/td_tj.jpeg" class="card-img-top" alt="Fissure in Sandstone" />
                    </div>
                </div>
            </div>

            <div class="p-4">
                <div class="card">
                    <div class="card-body">
                        <img src="https://maorif.tj/storage/image/me_tj.jpeg" class="card-img-top" alt="Fissure in Sandstone" />
                    </div>
                </div>
            </div>
            <div class="p-4">
                <div class="card">
                    <div class="card-body">
                        <a href='https://maorif.tj/pages/covid-19-tj'>
                            <img src="https://maorif.tj/storage/image/covid_tj.jpeg" class="card-img-top" alt="Fissure in Sandstone" />
                        </a>
                    </div>
                </div>
            </div>
            <div class="p-4">
                <div class="card">
                    <p class="card-text text-center pt-4"><b>ТАҚВИМ</b> </p>
                    <div className="card">
                        <Calendar
                            value={dateState}
                            onChange={changeDate}
                            className="border-0 card"
                        />
                    </div>
                </div>
            </div>
            <div class="p-4">
                <div class="card">
                    <p class="card-text text-center pt-4"><b>ОБУ ХАВО</b> </p>

                    <div class=" card card-body">
                        <a href='https://www.gismeteo.ru/weather-dushanbe-5358/'>
                            <img src="https://cdn-englishdom.gcdn.co/dynamicus/blog-post/000/002/152/1605621888_content_700x455.jpg" class="card-img-top" alt="Fissure in Sandstone" />
                        </a>
                    </div>
                </div>
            </div>
            <div class="p-4">
                <div class="card">
                    <p class="card-text text-center pt-4"><b>ОМОР</b> </p>

                    <div class="card card-body">
                        <img src="https://s01.flagcounter.com/count2/6Kyg/bg_FFFFFF/txt_000000/border_FFFFFF/columns_3/maxflags_21/viewers_3/labels_0/pageviews_0/flags_0/" class="card-img-top" alt="Fissure in Sandstone" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RightSidebar;